import { Injectable } from '@angular/core';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { NavigationItem } from './navigation-item.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorageService } from '../../shared/services/storage.service';
import { AuthService } from '../../shared/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationLoaderService {
  private readonly _items: BehaviorSubject<NavigationItem[]> =
    new BehaviorSubject<NavigationItem[]>([]);
  account: any = [];
  get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }

  constructor(
    private readonly layoutService: VexLayoutService,
    private authService: AuthService
  ) {
    const access_token = StorageService.getItem('accessToken');
    if (access_token) {
      this.authService.self().subscribe((data) => {
        this.account =
          data && data['added_by_type'] === 'EMPLOYEE' ? ['STUDENT'] : [];
        this.loadNavigation();
      });
    } else {
      this.loadNavigation();
    }
  }

  loadNavigation(): void {
    this._items.next([
      {
        type: 'subheading',
        label: 'Dashboard',
        availableTo: ['ENTRANCE_STUDENT'],
        children: [
          {
            type: 'link',
            label: 'Home',
            route: '/home',
            icon: 'mat:home',
            routerLinkActiveOptions: { exact: true },
            availableTo: ['ENTRANCE_STUDENT']
          }
        ]
      }
    ]);
  }
}
